import { detail } from './detail';
import { table } from './table';

export const contactRequests = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},

  modules: {
    detail,
    table,
  },
};
